import api from "../../utils/api";
import { apiPath } from "../../utils/apiPath";

export const employeeListApi = async (payload) => {
    return await api.get(
        `${apiPath.API_URL}${apiPath.EmployeeMaster.fetch_employee}`,
        {
       params: payload 
    }
    )
}

export const createEmployeeApi = async (payload) =>{
    return await api.post(
        `${apiPath.API_URL}${apiPath.EmployeeMaster.employee_master}`,
        payload
    )
}

export async function getEmployeeByIdApi(EmployeeCode) {
  const response = await api.get(
    `${apiPath.API_URL}${apiPath.EmployeeMaster.get_employee}/${EmployeeCode}`
  );

  return response.data;
}

export async function updateEmployeeApi(EmployeeCode, payload) {
  return await api.put(
      `${apiPath.API_URL}${apiPath.EmployeeMaster.update_employee}/${EmployeeCode}`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

export async function deleteMessageEmployeeApi(EmployeeCode) {
  const response = await api.get(
    `${apiPath.API_URL}${apiPath.EmployeeMaster.delete_message_employee}/${EmployeeCode}`
  );

  return response.data;
}

export async function deleteEmployeeApi(EmployeeCode) {
  const response = await api.delete(
    `${apiPath.API_URL}${apiPath.EmployeeMaster.delete_employee}/${EmployeeCode}`
  );

  return response.data;
}